import { RouteObject } from 'react-router';

import { BUSINESS_ROUTES } from './Businesses/routes';
import { BUSINESS_MENU_ROUTES } from './BusinessMenu/routes';
import { CORE_ROUTES } from './Core/routes';
import { CUSTOMER_ROUTES } from './Customers/routes';
import { Dashboard } from './Dashboard';
import { MASTER_MENU_ROUTES } from './MasterMenu/routes';
import { ORDERS_ROUTES } from './Orders/routes';
import { PLACES_ROUTES } from './Places/routes';
import { PRODUCT_ROUTES } from './Products/routes';
import { REPORTS_ROUTES } from './Reports/routes';
import { SIGNUP_ROUTES } from './Signups/routes';
import { USER_ROUTES } from './Users/routes';

export const ADMIN_ROUTES: RouteObject[] = [
    {
        index: true,
        Component: Dashboard,
    },
    {
        path: 'orders',
        children: ORDERS_ROUTES,
    },
    {
        path: 'reports',
        children: REPORTS_ROUTES,
    },
    {
        path: 'users',
        children: USER_ROUTES,
        // path: 'users/:id?/*',
        // Component: Users,
    },
    {
        path: 'customers',
        children: CUSTOMER_ROUTES,
    },
    {
        path: 'places',
        children: PLACES_ROUTES,
    },
    {
        path: 'businesses',
        children: BUSINESS_ROUTES,
    },
    {
        path: 'core',
        children: CORE_ROUTES,
    },
    {
        path: 'products',
        children: PRODUCT_ROUTES,
    },
    {
        path: 'master-menu',
        children: MASTER_MENU_ROUTES,
    },
    {
        path: 'business-menu',
        children: BUSINESS_MENU_ROUTES,
    },
    {
        path: 'signups',
        children: SIGNUP_ROUTES,
    },
];
